import { render, staticRenderFns } from "./otptelegram.vue?vue&type=template&id=4053cbdd&scoped=true&lang=pug&"
import script from "./otptelegram.vue?vue&type=script&lang=js&"
export * from "./otptelegram.vue?vue&type=script&lang=js&"
import style0 from "./otptelegram.vue?vue&type=style&index=0&id=4053cbdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4053cbdd",
  null
  
)

export default component.exports